import {
  makeObservable, observable, action, runInAction
} from 'mobx';
// eslint-disable-next-line import/no-cycle
import api from '../api';
import { convertPropertiesToCamelCase } from '../utils/shared';
/*import moment from 'moment';
import { DATE_FORMAT } from '../constants/settings';*/

class CompanyStore {
  isLoading = false;

  name = '';

  companyId = '';

  licenseKey = '';

  savedLicenseKey = '';

  licenseStartDate = '';

  licenseExpirationDate = '';

  licenseType = '';

  quotaAll = '';

  quotaDaily = '';

  use_ldap = '';

  use_smtp = '';

  vulnDb = false;

  allowShowStorageInfo = false;

  licenseInfo = {};

  isFileUploaded = false;

  updateErrorMessages = [];

  about = {};

  quota = {};

  quotadata = [];

  overview = {};

  comoverview = {};

  secoverview = {};

  licoverview = {};

  poloverview = {};

  detailSummary = {};

  comDetailSummary = {};

  secDetailSummary = {};

  licDetailSummary = {};

  policySum = {};

  revisionSum = {};

  policySumDetail = {};

  revisionFileName = '';

  nickName = '';

  password = '';

  protocol = '';

  baseUrl = '';

  address = '';

  domain = '';

  host = '';

  port = '';

  isUseUpdater = false;

  authentication = 'login';

  enable_starttls_auto = true;

  isLoadError = false;

  systemObj = {};

  awsObj = {};

  isUseLoadBalancer = false;

  scanNotificationEmail = [];

  constructor() {
    makeObservable(this, {
      isLoading: observable,
      name: observable,
      companyId: observable,
      licenseKey: observable,
      savedLicenseKey: observable,
      licenseStartDate: observable,
      licenseExpirationDate: observable,
      licenseType: observable,
      quotaAll: observable,
      quotaDaily: observable,
      use_ldap: observable,
      use_smtp: observable,
      vulnDb: observable,
      allowShowStorageInfo: observable,
      licenseInfo: observable,
      isFileUploaded: observable,
      updateErrorMessages: observable,
      about: observable,
      quota: observable,
      quotadata: observable,
      overview: observable,
      comoverview: observable,
      secoverview: observable,
      licoverview: observable,
      poloverview: observable,
      detailSummary: observable,
      comDetailSummary: observable,
      secDetailSummary: observable,
      licDetailSummary: observable,
      policySum: observable,
      revisionSum: observable,
      policySumDetail: observable,
      revisionFileName: observable,
      nickName: observable,
      password: observable,
      protocol: observable,
      baseUrl: observable,
      address: observable,
      domain: observable,
      host: observable,
      port: observable,
      isUseUpdater: observable,
      authentication: observable,
      enable_starttls_auto: observable,
      isLoadError: observable,
      systemObj: observable,
      awsObj: observable,
      isUseLoadBalancer: observable,
      scanNotificationEmail: observable,
      saveCompanyData: action,
      useLdap: action,
      useSmtp: action,
      saveEmailData: action,
      fetchCompanySettings: action,
      updateCompanySettings: action,
      fetchAbout: action,
      fetchQuota: action,
      fetchQuotaData: action,
      useUpdatersMenu: action,
      resetLoadingStatus: action,
      resetUpdateError: action,
      setDates: action,
      setLicenseKey: action,
      setName: action,
      setVulnDb: action,
      setIsFileUploaded: action,
      setLicenseInfo: action,
      setBaseUrl: action,
      setProtocol: action,
      setNickName: action,
      setPassword: action,
      setAddress: action,
      setDomain: action,
      setHost: action,
      setPort: action,
      setAuthentication: action,
      setEnableStarttlsAuto: action,
      setRevisionfileName: action,
      setScanNotificationEmail: action,
      setOverviewSummary: action,
      setOverviewSummaryDetail: action,
      setComponentSummary: action,
      setComponentSummaryDetail: action,
      setSecuritySummary: action,
      setSecuritySummaryDetail: action,
      setLicenseSummary: action,
      setLicenseSummaryDetail: action,
      setPolicySummary: action,
      setPolicySummaryDetail: action,
      setPolicyRevisionSummary: action,
    });
  }

  saveCompanyData(data) {
    this.name = data.name || '';
    this.companyId = data.company_id || '';
    this.licenseKey = data.license_key || '';
    this.savedLicenseKey = data.saved_license_key || '';
    this.use_ldap = data.use_ldap || false;
    this.use_smtp = data.use_smtp || false;
    this.licenseStartDate = data.license_start_date || '';
    this.licenseExpirationDate = data.license_expiration_date || '';
    this.licenseType = data.license_type || '';
    this.quotaAll = data.quota_all || '';
    this.quotaDaily = data.quota_daily || '';
    this.vulnDb = data.vuln_db || false;
    this.scanNotificationEmail = data.scan_notification_email || [];
  }

  useLdap(status) {
    this.use_ldap = status;
  }

  useSmtp(status) {
    this.use_smtp = status;
  }

  saveEmailData(data) {
    this.nickName = data.username || '';
    this.password = data.password || '';
    // this.protocol = data.protocol || '';
    this.address = data.from || '';
    this.domain = data.domain || '';
    this.host = data.address || '';
    this.port = data.port || '';
    this.enable_starttls_auto = String(data.enable_starttls_auto) || 'true';
  }

  fetchCompanySettings = async () => {
    await api.getCompanySettings().then((response) => {
      runInAction(() => {
        this.saveCompanyData(response.response);
        this.saveEmailData(response.response.email_set);
        this.isLoading = false;
        this.isLoadError = false;
      });
    }).catch((err) => {
      console.log(err);
      this.isLoadError = true;
      this.isLoading = false;
    });
  };

  setOverviewSummary(obj) {
    this.overview = obj;
  }

  setOverviewSummaryDetail(obj) {
    this.detailSummary = obj;
  }

  setComponentSummary(obj) {
    this.comoverview = obj;
  }

  setComponentSummaryDetail(obj) {
    this.comDetailSummary = obj;
  }

  setSecuritySummary(obj) {
    this.secoverview = obj;
  }

  setSecuritySummaryDetail(obj) {
    this.secDetailSummary = obj;
  }

  setLicenseSummary(obj) {
    this.licoverview = obj;
  }

  setLicenseSummaryDetail(obj) {
    this.licDetailSummary = obj;
  }

  setPolicySummary(obj) {
    this.policySum = obj;
  }

  setPolicySummaryDetail(obj) {
    this.policySumDetail = obj;
  }

  setPolicyRevisionSummary(obj) {
    this.revisionSum = obj;
  }

  updateCompanySettings(isNew, isAdmin) {
    this.isLoading = true;

    const data = {
      name: this.name,
      license_key: this.licenseKey,
    };

    if (!isNew) {
      data.selected_company_id = this.companyId;
    }

    if (isAdmin) {
      data.username = this.nickName;
      data.password = this.password;
      data.address = this.address;
      data.domain = this.domain;
      data.port = this.port;
      data.from = this.host;
    }

    delete this.licenseInfo.name;

    if (this.isFileUploaded) {
      data.apply_method = 'upload';
      Object.assign(data, this.licenseInfo);
    } else {
      data.apply_method = 'string';
    }

    if (isNew) {
      api
        .createCompanySettings(data)
        .then((response) => {
          this.saveCompanyData(response.response);
        })
        .catch((err) => {
          const o = err.data.response;
          if (o.error_description) {
            this.updateErrorMessages = o.error_description;
          } else {
            this.updateErrorMessages = 'Unknown error. Please contact Insignary.';
          }
        })
        .then(() => {
          this.isLoading = false;
        });
    } else {
      api
        .updateCompanySettings(data)
        .then((response) => {
          this.saveCompanyData(response.response);
        })
        .catch((err) => {
          const o = err.data.response;
          if (o.error_description) {
            this.updateErrorMessages = o.error_description;
          } else {
            this.updateErrorMessages = 'Unknown error. Please contact Insignary.';
          }
        })
        .then(() => {
          this.isLoading = false;
        });
    }
  }

  fetchAbout() {
    return api.getAbout().then(
      action((response) => {
        this.about = convertPropertiesToCamelCase(response.response);
        this.isLoading = false;
      })
    );
  }

  fetchQuota() {
    return api.getQuota().then((response) => {
      this.quota = convertPropertiesToCamelCase(response.response);
      this.isLoading = false;
    });
  }

  fetchQuotaData() {
    return api.getQuotaData().then((response) => {
      this.quotadata = convertPropertiesToCamelCase(response.response.quota);
      this.isLoading = false;
    });
  }

  useUpdatersMenu = async () => {
    this.isLoading = true;
    await api.useUpdatersMenu().then((response) => {
      runInAction(() => {
        this.isUseUpdater = response.response.updater;
        this.systemObj = { ...response.response.system };
        this.awsObj = { ...response.response.cloud_integrations };
        this.isUseLoadBalancer = response.response.load_balancer;
        this.isLoading = false;
      });
    });
  };

  resetLoadingStatus() {
    this.isLoading = false;
  }

  resetUpdateError() {
    this.updateErrorMessages = [];
  }

  setDates(start, end) {
    this.licenseStartDate = start;
    this.licenseExpirationDate = end;
  }

  setLicenseKey(key) {
    this.licenseKey = key;
  }

  setName(name) {
    this.name = name;
  }

  setVulnDb(value) {
    this.vulnDb = value;
  }

  setIsFileUploaded(value) {
    this.isFileUploaded = value;
  }

  setLicenseInfo(obj) {
    this.licenseInfo = obj;
  }

  setBaseUrl(value) {
    this.baseUrl = value;
  }

  setProtocol(value) {
    this.protocol = value;
  }

  setNickName(value) {
    this.nickName = value;
  }

  setPassword(value) {
    this.password = value;
  }

  setAddress(value) {
    this.address = value;
  }

  setDomain(value) {
    this.domain = value;
  }

  setHost(value) {
    this.host = value;
  }

  setPort(value) {
    this.port = value;
  }

  setAuthentication(value) {
    this.authentication = value;
  }

  setEnableStarttlsAuto(value) {
    this.enable_starttls_auto = value;
  }

  setRevisionfileName(value) {
    this.revisionFileName = value;
    localStorage.setItem('revisionFileName', value);
  }

  setScanNotificationEmail(value) {
    this.scanNotificationEmail = value;
  }
}
export default CompanyStore;
